import { Record } from 'immutable'

export interface ISignType {
  readonly id: string
  readonly name: string
}

const SignTypeRecord = Record({
  id: '',
  name: '',
})

export class SignType extends SignTypeRecord implements ISignType {
  public static fromJS(initialState?: Partial<ISignType>) {
    return new SignType(initialState)
  }

  public readonly id: string
  public readonly name: string

  constructor(props?: Partial<SignType>) {
    props ? super(props) : super()
  }
}
